
import { createStore, combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import localforage from 'localforage'
import { todayDataReducer, todayDataOfDeviceReducer } from './reducer/TodayData'
import { loginDetailReducer } from './reducer/login'
import { loadMultipleDataReducer } from './reducer/totalData'
import { houseDataReducer } from './reducer/house'
import { selectedDayReducer, selectedEndDayReducer } from './reducer/selectedDate'
import { dropdownSelectionData } from './reducer/deviceDropdownSelection'
import { unitSnapshotData } from './reducer/dailyUnit'
import { housesListReducer } from './reducer/housesList'
import { schedules } from './reducer/schedule'
import unitReportReducer from './reducer/report'
import { loadMultipleHouseData } from './reducer/collectiveHouse'
import { loadEnviroSynncReducer, loadThermoSmartReducer, loadWeatherReducer } from './reducer/devices'
import { vrvReducer } from './reducer/vrv'

const persistConfig = {
    key: 'persist-key',
    storage: localforage,
    blacklist:['unitReport', 'vrv']
}

const vrvPersistConfig = {
    key: 'vrv',
    storage: localforage,
    whitelist: ['selectedGateways'],
}

const persistedReducer = persistReducer(persistConfig, combineReducers({
    todayData: todayDataReducer,
    todayData2: todayDataOfDeviceReducer,
    login: loginDetailReducer,
    multipleData: loadMultipleDataReducer,
    houseData: houseDataReducer,
    selectedDate: selectedDayReducer,
    selectedEndDay: selectedEndDayReducer,
    dropdownSelectionData: dropdownSelectionData,
    snapshotUnit: unitSnapshotData,
    housesList:housesListReducer,
    schedules:schedules,
    unitReport:unitReportReducer,
    mutipleHouse:loadMultipleHouseData,
    thermoSmarts:loadThermoSmartReducer,
    weatherSensors:loadWeatherReducer,
    environSyncs:loadEnviroSynncReducer,
    vrv: persistReducer(vrvPersistConfig, vrvReducer)
}))

let store = createStore(persistedReducer);
let persistor = persistStore(store)
export default store;
export { persistor }